(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
    const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
    if (firstSectionImage) {
      firstSectionImage.setAttribute('loading', 'eager');
      firstSectionImage.setAttribute('fetchpriority', 'high');
    }
  
    document.addEventListener('DOMContentLoaded', () => {
      const bar = document.getElementById('mobile-bottom-bar');

      if (!bar) return;

      let lastScrollTop = window.pageYOffset;
      let idleTimer;
      let ticking = false;

      document.body.classList.add('bottom-bar-enabled');

      function activateBar() {
        bar.classList.add('active');
      }

      function shrinkBar() {
        bar.classList.remove('active');
      }

      function startIdleTimer() {
        clearTimeout(idleTimer);
        idleTimer = setTimeout(() => {
          shrinkBar();
        }, 5000);
      }

      startIdleTimer();
      updateBottomCartCount();
      initCartObserver();

      document.addEventListener('cart:updated', updateBottomCartCount);
      document.addEventListener('product:added', updateBottomCartCount);
      document.addEventListener('ajaxProduct:added', updateBottomCartCount);
      document.addEventListener('ajaxCart:updated', updateBottomCartCount);

      window.addEventListener('scroll', () => {
        if (ticking) return;
        requestAnimationFrame(() => {
          const currentScroll = window.pageYOffset;
          const delta = currentScroll - lastScrollTop;
          if (Math.abs(delta) > 8) {
            if (delta > 0) {
              shrinkBar();
            } else {
              activateBar();
            }
            lastScrollTop = currentScroll;
          }
          ticking = false;
        });

        ticking = true;
        clearTimeout(idleTimer);

        idleTimer = setTimeout(() => {
          shrinkBar();
        }, 5000);
      }, { passive: true });
    });

    function initCartObserver() {
      const headerCount = document.querySelector('.header__cart__status');

      if (!headerCount) return;
      const observer = new MutationObserver(() => {
        const count = parseInt(headerCount.textContent.replace(/\D/g, '')) || 0;
        const badge = document.getElementById('mobile-bottom-cart-count');

        if (!badge) return;

        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      });

      observer.observe(headerCount, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    async function updateBottomCartCount() {

      const response = await fetch('/cart.js');
      const cart = await response.json();

      const countElement = document.getElementById('mobile-bottom-cart-count');

      if (!countElement) return;
      countElement.textContent = cart.item_count;

      if (cart.item_count > 0) {
        countElement.style.display = 'flex';
      } else {
        countElement.style.display = 'none';
      }
    }

    function openCartDrawer() {
      const cartTrigger = document.querySelector('[data-cart-toggle]');
      if (cartTrigger) {
        cartTrigger.click();
      }
    }


  } catch(e) { console.error(e); }
})();
})();
